import { api } from '@api/api2';

export const getTicketTypes = () => api.v1('get', 'tck/types/list');
